import { http } from '@/lib/http';
import type { APIResponse } from '@/types';
import { CreatorListItem } from '../types';

export type GetBizCreatorListParams = {
  oemServiceId: number;
  requestTime: string;
  pagingBizCreatorId?: number;
  paging?: string;
  limit?: number;
  bizCreatorName?: string;
  bizTeamId?: number;
};

export type GetBizCreatorListResponse = APIResponse<Array<CreatorListItem>>;

export const getBizCreatorList = async (params: GetBizCreatorListParams) => {
  return await http<GetBizCreatorListResponse>('/user/v1/biz-creator', {
    query: {
      oem_service_id: params.oemServiceId,
      request_time: params.requestTime,
      paging_biz_creator_id: params.pagingBizCreatorId,
      paging: params.paging,
      limit: params.limit,
      biz_creator_name: params.bizCreatorName,
      biz_team_id: params.bizTeamId,
    },
  });
};
